import { Alert, AlertIcon, AlertTitle, AlertDescription } from '@chakra-ui/react'
import { MotionFlex } from 'components'
import React from 'react'

type ErrorIndicatorProps = {
  status: string
}
const ErrorIndicator: React.FC<ErrorIndicatorProps> = ({ status }) => {
  return (
    <MotionFlex
      animate={{ opacity: 1 }}
      initial={{ opacity: 0 }}
      justify="center"
      my={4}
      width="100%"
    >
      <Alert borderRadius="lg" status="error">
        <AlertIcon />
        <AlertTitle mr={2} fontSize="sm">
          Error:
        </AlertTitle>
        <AlertDescription fontSize="xs">{status}</AlertDescription>
      </Alert>
    </MotionFlex>
  )
}

export default ErrorIndicator
